import * as React from "react";
import { DownloadButton } from "./DownloadButton";
import { IButtonProps } from "./IButtonProps";

interface IDownloadFileButtonProps extends IButtonProps {
	id: string;
	ext: string;
	fileName: string;
}

export class DownloadFileButton extends React.Component<IDownloadFileButtonProps, {}> {

	get downloadUrl(): string {
		let path = encodeURI(`/files/${this.props.id}${this.props.ext}?docName=${encodeURIComponent(this.props.fileName)}`);
		return path;
	}

	render() {
		return <a href={this.downloadUrl} download={this.props.fileName}>
			<DownloadButton {...this.props} />
		</a>;
	}
}
